/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import { Styled } from 'components/ITeroTermsConditionsModal';
import { ServicePlanDetailsEMEAProps } from 'components/ITeroTermsConditionsModalEMEA/ITeroTermsConditionsModalEMEA.type';
import React from 'react';
import { ServicePlanTermEMEA } from '.';

const ServicePlanDetailsEMEA = ({
  currentProposal,
  i18n,
  isMultipleScannerSubscriptions,
}: ServicePlanDetailsEMEAProps) => {
  return (
    <>
      <p>
        <u>{i18n['Service Plan Details* - EMEA']}</u>
        <Styled.ServicePlanSubText>
          {i18n['Applicable after the initial service term expiration. - EMEA']}
        </Styled.ServicePlanSubText>
      </p>
      <Styled.Table>
        <thead>
          <tr>
            <Styled.Th>{i18n['Product(s)']}</Styled.Th>
            {isMultipleScannerSubscriptions && (
              <Styled.Th>{i18n['Related Scanner']}</Styled.Th>
            )}
            <Styled.Th>{i18n['Quantity']}</Styled.Th>
            <Styled.Th>{i18n['List Price']}</Styled.Th>
            <Styled.Th>{i18n['Total Promotion/Discount Amount']}</Styled.Th>
            <Styled.Th>{i18n['Total Price']}</Styled.Th>
          </tr>
        </thead>
        <tbody>
          {currentProposal?.lineitems.map(item => (
            <React.Fragment key={item.name}>
              {item.subscriptions?.map(subscription => (
                <React.Fragment key={subscription.name}>
                  <tr>
                    <Styled.Td>
                      <div>{subscription.name}</div>
                      <br />
                      <div>
                        <div>
                          <strong>
                            {i18n['Service Plan Fee Invoicing - EMEA']}
                          </strong>
                          : {subscription.servicePlan}
                        </div>
                      </div>
                    </Styled.Td>
                    {isMultipleScannerSubscriptions && (
                      <Styled.Td>{item.name}</Styled.Td>
                    )}
                    <Styled.Td>{subscription.quantity}</Styled.Td>
                    <Styled.Td>{subscription.displayItemUnitPrice}</Styled.Td>
                    <Styled.Td $width={'30%'}>
                      {i18n['iTero Total Promotion Discount Table text - EMEA']}
                    </Styled.Td>
                    <Styled.Td>{subscription.displayItemTotal}</Styled.Td>
                  </tr>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Styled.Table>
      <ServicePlanTermEMEA
        servicePlanFee={
          currentProposal.lineitems[0].subscriptions[0].displayItemUnitPrice
        }
      />
    </>
  );
};

export default ServicePlanDetailsEMEA;
